define('shared/util/providers/data/orderDate',['shared/util/state', 'shared/util/registers/DataProvider', 'shared/lib/RSVP'], 
function(state, DataProvider, RSVP){
    var done;

    return {
        provide: function(){
            
            if ( done ) {
                return done;
            }

            done = RSVP.resolve()
                .then(function(){
                    return state.get('order.next_execution_date');
                })
                .then(function(values){
                    var next = values && values[0];

                    if ( next != null && next != '' ) {

                        var provider = {
                            id: 'orderRegularChargeDate',
                            value: function(){
                                return new Date(next);
                            }
                        };
                        DataProvider.instance.register( provider );
                    }

                    return RSVP.resolve();
                });

            return done;
        }
    };
});
